import { HOME_PATH } from "./paths";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

/** The content-area error boundary for the authenticated shell. A screen that
    throws (or a loader that rejects) lands here instead of react-router's raw
    developer overlay — the shell chrome stays, and the person gets a way out.
    Wired as `errorElement` on the pathless layout route that wraps the screens. */
export function RouteError() {
  const error = useRouteError();

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : null;

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-surface-2 text-[22px]">
        ⚠️
      </div>
      <div>
        <h1 className="text-[20px] font-bold tracking-tight">Algo ha fallado</h1>
        <p className="mt-1.5 max-w-[52ch] text-[13px] leading-relaxed text-dim">
          Esta pantalla no se ha podido cargar. Puedes reintentar o volver al inicio; si
          vuelve a pasar, avísanos.
        </p>
      </div>
      {detail && (
        <pre className="max-w-[52ch] overflow-x-auto rounded-lg border border-line bg-surface px-3 py-2 text-left text-[11.5px] text-mute">
          {detail}
        </pre>
      )}
      <div className="flex items-center gap-2.5">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex h-[36px] items-center rounded-lg bg-acc px-4 text-[13px] font-semibold text-acc-ink"
        >
          Reintentar
        </button>
        <Link
          to={HOME_PATH}
          className="inline-flex h-[36px] items-center rounded-lg border border-line bg-surface-2 px-4 text-[13px] font-semibold text-ink hover:bg-surface-3"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
